import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://uhewcxvoiwtmkrxwqgrt.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVoZXdjeHZvaXd0bWtyeHdxZ3J0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQwNzE1NDcsImV4cCI6MjA2OTY0NzU0N30.R7LvLVOOCimdxtZGIm9GSG9XwWS8K4a4_7JH99WDkVM'


// Debug logging
console.log('🔍 Environment Variables Check:')
console.log('URL exists:', !!supabaseUrl)
console.log('Key exists:', !!supabaseAnonKey)
console.log('URL:', supabaseUrl)
console.log('Key starts with:', supabaseAnonKey.substring(0, 20) + '...')

if (!supabaseAnonKey) {
  console.error('❌ Missing Supabase API key!')
  console.error('Make sure your .env file has:')
  console.error('REACT_APP_SUPABASE_ANON_KEY=your_key')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey) 